var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiTable from '@material-ui/core/Table';
/**
 * Kareo wrapped component of the Material-UI Table. The prop API has been limited to props defined in TableProps.
 *
 * Tables display sets of data in a way that’s easy to scan, so that users can look for patterns and insights.
 *
 * The blue header table is used when there are many other components on the page and it needs to stand out.
 * On the other hand, the gray header table places less emphasis on the table when there are not a lot of components on the page.
 * Alternating row colors and blue header is used when there is a larger data set that needs readability.
 *
 * Material-UI Table: [Docs](https://v4.mui.com/components/tables/), [API](https://v4.mui.com/api/table/)
 *
 * @storybook: [Table](http://design.kareoprod.ent/design-system/?path=/story/components-data-display-table--table-main-story)
 */
var Table = React.forwardRef(function (props, ref) { return (React.createElement(MuiTable, __assign({}, props, { ref: ref }))); });
Table.displayName = 'KareoTable';
export default Table;
